import script from "./TheSideBarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSideBarItem.vue?vue&type=script&setup=true&lang=js"

import "./TheSideBarItem.vue?vue&type=style&index=0&id=60b162c6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b162c6"]])

export default __exports__